<template>
  <main>    
    <DashboardAdmin v-if="isAdmin"/>
    <Dashboard v-else />
  </main>
</template>

<script>
import Dashboard from '@/components/Dashboard.vue'
import DashboardAdmin from '@/components/DashboardAdmin.vue'

export default {
  components: { Dashboard, DashboardAdmin }
}
</script>